module.exports = __webpack_public_path__ + "img/mobile_btn5.8414e54c.png";